import { SettingsRepository } from "../repositories/SettingsRepository";

/**
 * ZOUR-19 — pulls the org's GST tax list from Zoho into the local `taxes` table.
 *
 * The same sync that runs by itself when the GST toggle flips off -> on. It is
 * also a button because that automatic run happens once: a client whose Zoho
 * tax set changed afterwards needs a way to catch up that is not the admin
 * screen.
 */
export class SyncGstTaxesUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(signal?: AbortSignal): Promise<{ added: number; total: number }> {
    return this.repository.syncGstTaxes(signal);
  }
}
